import Echo  from 'laravel-echo'
import Pusher from 'pusher-js'
import store  from '@/store'

export default {
  install (Vue, { options }) {
    console.log("echo install");
    window.Pusher = Pusher
    let echoInstance = null

    Vue.prototype.$echo = function() {
        if (echoInstance) return Promise.resolve(echoInstance)

        return store.dispatch('users/getMyUserHourApp', {
            ApiClient:   Vue.prototype.$ApiClient,
            departments: store.getters.getUserData.departments
        })
        .then(res => {
            
            if (res.status !== 200) {
                throw new Error('Failed to get user data for Echo initialization');
            }

            const user = res.data.data
            echoInstance = new Echo({
                broadcaster: 'reverb',
                authEndpoint: options.WS_AUTH,
                bearerToken: '',
                key: options.WS_KEY,
                wsHost: options.WS_HOST,
                wsPort: options.WS_PORT,
                wssPort: options.WS_PORT,
                wsPath: '/ws',
                forceTLS: true,
                enabledTransports: ['ws', 'wss'],
                auth: {
                    headers: {
                        Accept: 'application/json',
                        firebaseIdToken: Vue.prototype.$ApiClient.token
                    }
                }
            })

            // Add connection event listeners for debugging
            echoInstance.connector.pusher.connection.bind('connected', () => {
                console.log('Echo/Pusher connected successfully');
            });

            echoInstance.connector.pusher.connection.bind('disconnected', () => {
                console.log('Echo/Pusher disconnected');
            });

            echoInstance.connector.pusher.connection.bind('error', (error) => {
                console.error('Echo/Pusher connection error:', error);
            });

            console.log('Echo instance created');
            return echoInstance;
        })
        .catch(err => {
            console.error('Failed to init Echo', err)
            throw err;
        })
    }

    // Add a method to check if Echo is ready
    Vue.prototype.$echoReady = function() {
        return echoInstance !== null;
    }
  }
}
